import type { ThemeFit } from '../../../tailor'

/**
 * Urban Drip (apparels-2): how the inherited section schemas fit this theme's own section designs. `hide` lists the
 * fields its components never draw, so the editor only offers what changes the page (stored values are kept);
 * `keep` / `add` / `variantLabels` list the layouts its components draw, by name. Checked by
 * tests/section-contract.test.ts in storefront-nuxt.
 */
export const apparels2Fit: ThemeFit = {
  'account': { hide: ['signinRedirectPath'] },
  'announcement-bar': { hide: ['bgColor', 'textColor'] },
  'cart': { hide: ['loadingText', 'taxLabel', 'secureCheckoutText'] },
  'category': { hide: ['productCardVariant', 'initialPriceRange', 'showBreadcrumb'] },
  'checkout': { hide: ['loadingText', 'shippingCalculatingText', 'securePaymentText'] },
  'cta': { hide: ['bgColor'] },
  'featured-category': { hide: ['productCardVariant', 'noSelectionText', 'noProductsText'] },
  'features': { hide: ['bgStyle'] },
  'flash-sale': { hide: ['bgColor', 'products'] },
  'new-arrivals': { hide: ['products'] },
  'order-success': { hide: ['loadingText'] },
  'product-detail': { hide: ['loadingText', 'notFoundCode', 'notFoundText'], keep: ['v1', 'v2', 'v3', 'v6'], variantLabels: { v1: 'Standard', v2: 'Sale countdown band', v3: 'Large photo swatches', v6: 'Video under the photo' } },
  'shop-grid': { hide: ['productCardVariant', 'initialPriceRange', 'sortOldestLabel', 'sortNameDescLabel'] },
  'similar-products': { hide: ['productCardVariant'] },
  'blog': { keep: ['v1', 'v2'] },
  'coupon': { hide: ['coupons[].bgColor'] },
  'header': { hide: ['topbar[].phone', 'topbar[].email', 'topbar[].showSocials', 'topbar[].socialLinks'] },
  'footer': { hide: ['paymentMethods[].icon'] },
  // Theme tab: button settings no part of this theme reads (colours drive every primary button via the CTA).
  'buttons': { hide: ['appearance.buttons.primary[].radius', 'appearance.buttons.primary[].height', 'appearance.buttons.primary[].paddingX', 'appearance.buttons.primary[].label', 'appearance.buttons.outline[].radius', 'appearance.buttons.outline[].height', 'appearance.buttons.outline[].paddingX', 'appearance.buttons.outline[].label', 'appearance.buttons.outline[].hoverBg'] },
  // Corner roundness: this theme's corners are fixed by its design (no --radius-base / --radius-card).
  'design': { hide: ['radius'] },
  // Delivery time is shown on product cards only by Prottoho.
  'store-info': { hide: ['deliveryEta'] },
}
